/* tslint:disable */
/* eslint-disable */
/**
 * EMLINX API specification
 * This is API specification for EMLINX project.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ErrorResponse } from '../models';
// @ts-ignore
import { RefreshTokenResponse } from '../models';
/**
 * RefreshtokenApi - axios parameter creator
 * @export
 */
export const RefreshtokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Refresh Token
         * @summary POST Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRefreshToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RefreshtokenApi - functional programming interface
 * @export
 */
export const RefreshtokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RefreshtokenApiAxiosParamCreator(configuration)
    return {
        /**
         * Refresh Token
         * @summary POST Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRefreshToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefreshTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRefreshToken(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RefreshtokenApi.postRefreshToken']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * RefreshtokenApi - factory interface
 * @export
 */
export const RefreshtokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RefreshtokenApiFp(configuration)
    return {
        /**
         * Refresh Token
         * @summary POST Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRefreshToken(options?: any): AxiosPromise<RefreshTokenResponse> {
            return localVarFp.postRefreshToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RefreshtokenApi - object-oriented interface
 * @export
 * @class RefreshtokenApi
 * @extends {BaseAPI}
 */
export class RefreshtokenApi extends BaseAPI {
    /**
     * Refresh Token
     * @summary POST Refresh Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefreshtokenApi
     */
    public postRefreshToken(options?: RawAxiosRequestConfig) {
        return RefreshtokenApiFp(this.configuration).postRefreshToken(options).then((request) => request(this.axios, this.basePath));
    }
}

